import React, { useEffect, useState } from 'react';
import TController from './components/view/TController';
import { AutoComplete, IData } from './helpers/interface';
import { initialState } from './helpers/initialState';
import lodash from 'lodash';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box/Box';
import ChildHeader from '../../../components/ui/ChildHeader';
import {
  SaveButton,
  SubmitButton,
} from '../../../components/common/button/CustomButtons';
import { useAuth } from '../../../services/auth/AuthProvider';
import { useQuery } from '../../../hooks/UseQuery';
import useConfirm from '../../../components/common/useConfirm';

const View = () => {

  const [moduleData, setModuleData] = useState<IData>(
    lodash.cloneDeep(initialState),
  );

  const [autoCompleteList, setAutoCompleteList] = useState<AutoComplete[] | null>(null)
  const navigate = useNavigate();
  const { state } = useAuth();
  const isView = useQuery('isView') === 'true' ? true : false;
  const id = useQuery('id')

  const [DialogSubmit, confirmSubmit] = useConfirm(
    'Submit',
    'Are you sure you want to save this document?',
  );

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/noiseMonitoringReport/${id}`)
        .then((res) => {
          setModuleData(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);


  useEffect(() => {
    axios
      .get('/api/machineRoutes/machine/ForAutoComplete')
      .then((res) => {
        const data = res.data;
        data.forEach((res: any) => {
          res[
            'machine_no_name'
          ] = `${res['machine_no']} - ${res['machine_name']}`;
        });
        setAutoCompleteList(data)
      })
      .catch((err) => console.log(err));

  }, []);


  const handleSumbit = async (isSubmitted: boolean) => {
    const ans = await confirmSubmit();
    if (!ans) return;
    moduleData.isSubmitted = isSubmitted;
    if (id) {
      await axios
        .put(`/api/noiseMonitoringReport/${id}`, moduleData)
        .then((res) => {
          if (res.data.status === 'success') {
            alert('Updated Successfully');
          }
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post('/api/noiseMonitoringReport', moduleData)
        .then((res) => {
          if (res.data.status === 'success') {
            alert('created Successfully');
            navigate(-1);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <>
      <Box>
        <ChildHeader text="NOISE MONITORING REPORT CHECK SHEET">
          {!isView && (
            <>
              {state.user?.userType === state.IS.Supervisor && (
                <SaveButton
                  label="Save & Continue"
                  onClick={() => handleSumbit(false)}
                />
              )}
              <SubmitButton label={moduleData?._id?"Update":"Submit"} onClick={() => handleSumbit(true)} />
            </>
          )}
        </ChildHeader>
      </Box>
      <TController
        {...{
          moduleData,
          isView,
          autoCompleteList
        }}
      />

      <DialogSubmit />
    </>
  );
};

export default View;
